import GET_ORG_UNITS_DETAILED_REPORT from '../queries/getOrgUnitDetailedReportQuery';
import moment from 'moment';
import GET_FDA_DETAILED_APPRAISAL_REPORT from '../queries/getFdaDetailedAppraisalReportQuery';
import { convertArrayToCSV } from 'convert-array-to-csv';
import { AppraisalReportsService } from '../../shared/services/appraisalReportsService';

export const getDetailedCsvData = async (orgUnitId, gettingFdaSharedData = false) => {
  const queryData = await fetchData(orgUnitId, gettingFdaSharedData);
  const orgUnit = !gettingFdaSharedData
    ? queryData.detailedOrgUnitReport
    : queryData.fdaDetailedAppraisalReport;

  const preparedData = await prepareData(
    orgUnit,
    queryData.practiceAreas,
    gettingFdaSharedData || queryData.isPercentageVisible
  );
  return preparedData;
};

const fetchData = async (orgUnitId, gettingFdaSharedData) => {
  if (!orgUnitId) throw new Error('No Org Unit ID selected.');

  const apollo = require('../../../apollo/configureApollo').default();

  const result = await apollo.query({
    query: !gettingFdaSharedData
      ? GET_ORG_UNITS_DETAILED_REPORT
      : GET_FDA_DETAILED_APPRAISAL_REPORT,
    variables: {
      id: orgUnitId
    },
    fetchPolicy: 'cache-first'
  });

  if (result.error) {
    throw new Error(result.error);
  }

  return result.data;
};

const prepareData = async (orgUnit, existingPracticeAreas, isPercentageVisible) => {
  const fileDateSet = new Set();

  const maxPracticeGroupLevels = AppraisalReportsService.getMaxLevelWithinGroups(
    orgUnit.AppraisalOrgUnits,
    true,
    existingPracticeAreas
  );

  return orgUnit.AppraisalOrgUnits.map(aou => {
    const reportPracticeAreas = AppraisalReportsService.getAppraisalOrgUnitDetailedReportData(
      aou,
      maxPracticeGroupLevels,
      isPercentageVisible,
      existingPracticeAreas
    );

    const reportRows = reportPracticeAreas.map(pa => getReportRows(pa, aou, isPercentageVisible));

    return {
      fileIdenfitifier: getFileIdentifier(aou, fileDateSet),
      Data: convertArrayToCSV(reportRows)
    };
  });
};

const getReportRows = (row, appraisalOrgUnit, isPercentageVisible) => {
  const csvRow = {
    'Program Year': `${appraisalOrgUnit.AppraisalProgramYear}`,
    'Practice Area': row.practiceArea.displayName
  };

  row.practices.forEach(practice => {
    const practiceColumn = `${practice.groupLevel}.${practice.numberWithinLevel}`;
    csvRow[practiceColumn] = practice.characterizationEvaluation;
  });

  if (isPercentageVisible) {
    const percentageHeader = `${
      row.aggregatePercentage.appraisalOrgUnitAggregatePercentage || ''
    }%`;
    csvRow[percentageHeader] = `${row.aggregatePercentage.practiceAreaPercentage || ''}%`;
  }

  return csvRow;
};

const getFileIdentifier = (appraisalOrgUnit, fileDateSet) => {
  let fileDate = moment(appraisalOrgUnit.Appraisal.ConductAppraisalEndDate).local().format('YYMM');

  let num = 1;
  while (fileDateSet.has(fileDate)) {
    fileDate = fileDate + ` (${num})`;
    num++;
  }

  fileDateSet.add(fileDate);
  return fileDate;
};
